import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import axios from 'axios';

export async function GetCustomerBalance(data){
    try{
        const response = await axios.post(
            MainAddress+"AccountBalance/read_customerAccountBalance.php",
            {
                ...data,
                serial_program:GetSerialProgram(),
                
            }
          )
        if(response.data[0].success){
            return response.data;
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}